import ije from "../../assets/Images/Works/Ip.png";

export default function AllWorks() {
  return <div className=" lg:h-full w-full">Loading......</div>;
}
